<template>
    <SwLayout>
        <div class="dm-wizard-field" v-if="presentation">
            <FullManuscriptUploader v-if="presentation && presentation.id" />
            <SampleManuscriptUploader v-if="presentation && presentation.id" />
            <IllustrationsManager />
        </div>
    </SwLayout>
</template>

<script>
import { validationMixin } from "@/mixins/validationMixin.js";
import { useSubmissionWizardStore } from "@storesSw/SubmissionWizardStore";
import { mapWritableState } from "pinia";
import SampleManuscriptUploader from "./partials/SampleManuscriptUploader.vue";
import FullManuscriptUploader from "./partials/FullManuscriptUploader.vue";
import IllustrationsManager from "./partials/illustrations/IllustrationsManager.vue";

export default {
    mixins: [validationMixin],

    components: {
        SampleManuscriptUploader,
        FullManuscriptUploader,
        IllustrationsManager,
    },

    data() {
        return {
            sample_uploader_key: 10000,
            full_uploader_key: 20000,
        };
    },

    computed: {
        ...mapWritableState(useSubmissionWizardStore, [
            "presentation",
            "bottom_navigation_rules",
        ]),

        isValid() {
            if (!this.presentation) return false;
            return (
                this.presentation.sample_uploaded ||
                this.presentation.full_uploaded
            );
        },
        token() {
            return document.head.querySelector('meta[name="csrf-token"]')
                .content;
        },
    },
};
</script>
